import type { Distance, Rectangle } from "@pdfking/math"
import { Min, Scale, Total } from "@pdfking/math"
import { MM } from "@pdfking/quantity"

// The logo, a disc as wide as 8% of the page's short side, and the gap what
// is above the footer keeps
const LOGO = 0.08
const FOOTER_GAP = MM(5)

/** The logo's height on a page of `size`, the footer's (see DrawFooter), and
 * with the gap above it, how much of the page's foot it takes. */
export const LogoFooterHeight = (size: Rectangle<Distance>, gap = true): Distance =>
  Total(Scale(Min(size.width, size.height), LOGO), gap ? FOOTER_GAP : MM(0))
